export default {
  1: {
    title: {
      en: 'Pick a&nbsp;new&nbsp;scent monthly',
    },
    description: {
      en: 'Select from 450+&nbsp;designer and&nbsp;niche perfumes',
    },
  },
  2: {
    title: {
      en: 'A&nbsp;rollerball size perfume',
    },
    description: {
      en: 'Get a&nbsp;0.27oz sprayer in&nbsp;a&nbsp;chic metal case, enough to&nbsp;last a&nbsp;month of&nbsp;more than 4x daily sprays',
    },
  },
  3: {
    title: {
      en: 'Just {subscriptionPrice}/mo. free shipping',
    },
    description: {
      en: 'One perfume of&nbsp;your choice is&nbsp;delivered right to&nbsp;your doorstep every month',
    },
  },
}
